import {z} from 'zod'

export const durationUnitSchema = z.object({
    durationEstimated: z.boolean(),
    timeBased: z.boolean(),
    dateBased: z.boolean(),
})

export const sessionDurationSchema = z.object({
    seconds: z.number(),
    zero: z.boolean(),
    nano: z.number(),
    negative: z.boolean(),
    positive: z.boolean(),
    units: z.array(durationUnitSchema),
})

export const baseUserSchema = z.object({
    user: z.string(),
    username: z.string(),
})

export const userSchema = z.object({
    ...baseUserSchema.shape,
    roles: z.array(z.string()),
    external: z.boolean(),
    email: z.string(),
    deleted: z.boolean(),
    emailNotificationEnabled: z.boolean(),
    internalUser: z.boolean(),
    active: z.boolean(),
    locations: z.array(z.string()).optional(),
    sessionDuration: sessionDurationSchema.optional(),
    assignedTag: z.string().optional(),
    notificationEmail: z.string().optional(),
    strictMode: z.string().optional(),
})

export type DurationUnit = z.infer<typeof durationUnitSchema>
export type SessionDuration = z.infer<typeof sessionDurationSchema>
export type User = z.infer<typeof userSchema>

export interface UserResponse {
    users: User[]
}
